"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var WarningIcon = function WarningIcon() {
  return _react.default.createElement("svg", {
    width: "52px",
    height: "45px",
    viewBox: "0 0 52 45",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "B72F53FF-2D48-470D-8FE6-35F972245233"), _react.default.createElement("desc", null, "Created with sketchtool."), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Modal-Component",
    transform: "translate(-1541.000000, -631.000000)",
    fill: "#FFBF00",
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M1541,675.5 L1593,675.5 L1567,631.5 L1541,675.5 Z M1570,669.5 L1565,669.5 L1565,664.5 L1570,664.5 L1570,669.5 Z M1570,659.5 L1565,659.5 L1565,650.5 L1570,650.5 L1570,659.5 Z",
    id: "Warning-Icon"
  }))));
};

var _default = WarningIcon;
exports.default = _default;